export const FILE_CONTEXT_VALUES = [
  'measurementReport',
  'projectBlueprint',
  'reportLogo',
  'StrengthTestResult',
] as const;

export type FileContext = typeof FILE_CONTEXT_VALUES[number];
